import { Link } from 'react-router-dom';
import { siteStats } from '@/mocks/site';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bold%20flat%20editorial%20illustration%20of%20a%20playful%20crowd%20of%20quirky%20cartoon%20characters%20pointing%20at%20a%20giant%20watermelon%20under%20a%20spotlight%2C%20warm%20cream%20sky%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20dramatic%20composition%2C%20no%20text&width=1600&height=900&seq=gq-hero-01&orientation=landscape"
          alt="一群围观奇葩事件的卡通人物插画"
          title="猎奇吃瓜 - 围观奇葩人物与迷惑行为"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>
      </div>

      <div className="relative w-full px-4 pb-12 pt-20 md:px-8 md:pb-16 md:pt-28">
        <div className="mx-auto max-w-3xl text-center gq-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur">
            <i className="ri-flashlight-fill text-accent-400" aria-hidden="true"></i>
            今日已更新 36 条，瓜田管够
          </span>
          <h1 className="mt-6 font-heading text-4xl leading-tight text-white md:text-6xl">
            猎奇吃瓜
          </h1>
          <p className="mt-4 font-heading text-xl text-accent-300 md:text-3xl">
            每天都有瓜，今天特别离谱
          </p>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/90 md:text-base">
            奇葩人物、迷惑行为、沙雕新闻、离谱故事、搞笑怪事、魔幻现实，六个栏目天天更新。
            想看魔幻操作，点开这里就能围观吃瓜，收获离谱又上头的快乐。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#hot"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-primary-600 sm:w-auto dark:text-white"
            >
              <i className="ri-fire-line text-lg" aria-hidden="true"></i>
              先吃今日热瓜
            </a>
            <a
              href="#categories"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-6 py-3 text-sm font-bold text-white backdrop-blur transition-colors hover:bg-white/20 sm:w-auto"
            >
              <i className="ri-layout-grid-line text-lg" aria-hidden="true"></i>
              按主题翻瓜
            </a>
          </div>
        </div>

        <dl className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-white/20 bg-white/10 px-4 py-4 text-center backdrop-blur"
            >
              <span className="flex items-center justify-center gap-1 text-xs text-white/80">
                <i className={stat.icon} aria-hidden="true"></i>
                {stat.label}
              </span>
              <dd className="mt-1 font-heading text-xl text-white md:text-2xl">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}